import { getLabel, TApiaFunction } from '@apia/util';
import { QueryControllerStructure } from '../../../../queries/QueryController';
import { QueryModalController } from '../../../../queries/QueryModalController';
import { GenericListQuery } from './GenericListQuery';
type TPoolsParameters = {
  showCurrentEnv?: boolean;
  showGlobal: boolean;
};

export class PoolsQuery extends GenericListQuery {
  constructor(protected config?: TPoolsParameters) {
    super('apia.modals.PoolsAction.run');
  }
  protected getRefreshParameters(): Record<string, unknown> {
    return {
      ...super.getRefreshParameters(),
      showAutogenerated: false,
      showNotAutogenerated: false,
      showCurrentEnv: this.config?.showCurrentEnv ?? true,
      showGlobal: this.config?.showGlobal ?? true,
      selectOnlyOne: false,
      forHierarchy: false,
      showOnlyPoolsInHierarchy: false,
      showOnlyPoolsOutsideHierarchy: false,
      refreshParameters: false,
      fetchAllInHierarchy: false,
    };
  }
  protected getFiltersValuesMap(): Record<string, unknown> {
    return {
      ...super.getFiltersValuesMap(),
    };
  }

  protected parseRefreshResponse(response?: TApiaFunction | null) {
    if (!response) return;

    const structure = this.parseLoadStructureResponse(response);
    this.parseStructure(structure);

    setTimeout(() => {
      super.parseRefreshResponse(response);
    }, 0);
  }

  protected parseLoadStructureResponse(
    response: any,
  ): QueryControllerStructure {
    const structure = { ...super.parseLoadStructureResponse(response) };
    structure.hideFilterTypes = true;
    structure.title = getLabel('btnAddPool').text;
    return structure;
  }
}

export const makeApiaPoolsModals2 = (config?: TPoolsParameters) =>
  new QueryModalController(new PoolsQuery(config));
